module.exports = __webpack_public_path__ + "media/images/slide_4-bf551e6672e9d7272e49996e9fe660f9.png";